import './timePicker.css';

const TimePicker = ({ name, time, getTime, validation, onChange }) => {
  const onChangeHandler = (e) => {
    getTime((time) => ({ ...time, [name]: e.target.value }));
    if (typeof onChange === "function") onChange(e);
  };
  return (
    <div className={`time-picker-wrapper ${!validation ? "not-valid" : ""}`}>
      <label htmlFor={name}>
        Time <span>*</span>
      </label>
      <input
        onChange={onChangeHandler}
        type="time"
        name={name}
        value={time ? time : ""}
      />
    </div>
  );
};

export default TimePicker;